/* eslint-disable @typescript-eslint/ban-ts-comment */
import { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import ErrorComponent from "web/Layout/Common/ErrorComponent";
import Loading from "web/Layout/Common/Loading";
import GtmEvent from "web/Layout/Gtm/GtmEvent";

import { useGetCampaignsQuery } from "web/features/api/graphQLApiSlice";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import getPageReferrer from "web/utils/system/GTM/getPageReferrer";
import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import placements from "web/constants/campaignGraphics";

import { ICampaign } from "web/types/CampaignGraphics";
import type { IStoreConfig } from "web/types/StoreConfig";

import Tourism from "./tourism";

const DomesticTourismContainer = memo(() => {
  const storeConfig = useSelector(
    (state) => state.app.storeConfig
  ) as IStoreConfig;
  const location = useLocation();

  const { data: campaigns, isLoading: loading, error } = useGetCampaignsQuery({
    placement: placements.tourismBanner,
  });

  const campaignGraphic = isArrayHasItems(campaigns) ? campaigns[0] : null;

  const gtmOptions = useMemo(
    () => ({
      cgroup1: "Strona turystyki",
      page_referrer: getPageReferrer(location),
    }),
    [location]
  );

  switch (true) {
    case !!loading: {
      return <Loading />;
    }
    case !!error: {
      newRelicErrorReport(error, "web-app/web/Pages/Tourism/container.js - 45");
      console.error(error);
      return <ErrorComponent />;
    }
    default: {
      return (
        <>
          <Tourism
            campaignGraphic={campaignGraphic as ICampaign}
            storeConfig={storeConfig}
          />
          <GtmEvent options={gtmOptions} withUrl />
        </>
      );
    }
  }
});

export default DomesticTourismContainer;
